import {AgregarExterno} from "./AgregarExterno";
import {postExternFet, putExternFet} from "../../../services/familia/fet";

export const AddExternoFet = () => {
    return (
        <AgregarExterno post={postExternFet} familiaURL={"/familia/fet"} name={"Fundación Escuela Teresiana"} logo={"logoFET.png"} put={putExternFet}/>
    )
}